import type { AppDispatch } from '@store/types';

export enum ProductionInformationMessageType {
  ADDED_PRODUCTION_INFORMATION = 'addedProductionInformation',
}

export enum ImageDocumentMessageType {
  IMAGE_UPLOAD = 'imageUpload',
  IMAGE_DELETED = 'imageDelete',
  IMAGE_CROPPED = 'imageCropped',
  IMAGE_ROTATED = 'imageRotated',
  IMAGE_METADATA_UPDATED = 'imageMetadataUpdated',
}

export enum AnnotationMessageType {
  ANNOTATION_ADDED = 'annotationAdded',
  ANNOTATION_UPDATED = 'annotationUpdated',
  ANNOTATION_DELETED = 'annotationDeleted',
  ANNOTATIONS_PAGE_REPLACED = 'annotationsPageReplaced',
}

export enum MachineMessageType {
  MACHINE_STATUS_UPDATED = 'machineStatusUpdated',
}

export type MessageType = ImageDocumentMessageType | ProductionInformationMessageType | AnnotationMessageType | MachineMessageType;

export interface Message<T = any> {
  id: string; // Unique identifier for the message
  messageType: MessageType;
  payload?: T;
  ttl: number; // Time-to-live timestamp in milliseconds
}

export interface MessagesState {
  messages: Record<string | number, Message[]>;
  softDeletedMessages: Record<string | number, Message[]>;
}

export interface HandledMessage {
  key: string | number;
  message: Message;
}

export type MessageHandler = (envelope: HandledMessage) => Parameters<AppDispatch>[0];